import {
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST,
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS,
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE,
} from "../../constants/ActionTypes";
import { CorporationTelResearchApi } from "../api/CorporationTelResearchApi";

/*** GET /corporation_tel_researches/get_researched_tel_has_departments ***/
const getResearchedTelHasDepartmentsRequest = () => ({
  type: GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST,
});

const getResearchedTelHasDepartmentsSuccess = (data) => ({
  type: GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS,
  payload: {
    data: data.data,
  },
});

const getResearchedTelHasDepartmentsFailure = (error) => ({
  type: GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE,
  payload: {
    error: error,
  },
});

export function getResearchedTelHasDepartments(data) {
  return async (dispatch) => {
    dispatch(getResearchedTelHasDepartmentsRequest());

    CorporationTelResearchApi.getResearchedTelHasDepartments(data, dispatch)
      .then((response) => {
        dispatch(getResearchedTelHasDepartmentsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getResearchedTelHasDepartmentsFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/CorporationTelResearch.js